export const ABOUT_MAX_LENGTH = 4000;

/** HTML tags allowed in profile "about" (no links, media, scripts). */
export const ABOUT_ALLOWED_TAGS = [
  'p',
  'br',
  'strong',
  'b',
  'em',
  'i',
  'u',
  's',
  'del',
  'strike',
  'mark',
  'sub',
  'sup',
  'code',
  'pre',
  'h1',
  'h2',
  'h3',
  'blockquote',
  'ul',
  'ol',
  'li',
  'hr',
] as const;

export const ABOUT_FORBID_TAGS = [
  'a',
  'img',
  'script',
  'style',
  'iframe',
  'object',
  'embed',
  'link',
  'form',
  'input',
  'button',
  'video',
  'audio',
  'source',
  'svg',
  'table',
  'thead',
  'tbody',
  'tr',
  'td',
  'th',
] as const;

const TEXT_ALIGN_PATTERN = /^text-align:\s*(left|center|right|justify)\s*;?\s*$/i;

export const isAllowedAboutStyle = (value: string): boolean => TEXT_ALIGN_PATTERN.test(value.trim());
